import moment from 'jalali-moment';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { SurveyHttp } from '@/services';
import { STORAGE_SURVEY_KEY } from '@/configs';
import storage from '../helpers/storage';

export interface SurveyIgnore {
  id: number;
  expire: number;
}

export interface SurveyStore {
  loading: boolean;
  isEnabled: boolean;
  answers: any[];
  surveys: SurveyEntity[];
  activeSurveys: SurveyEntity[];
  ignore: SurveyIgnore[];
  ignoreSurvey: (id: number) => void;
  fetchSurveys: () => Promise<SurveyEntity[]>;
  filterActiveSurveys: () => SurveyEntity[];
}

export const writeSurveyCacheToStorage = (payload: any) => storage.writeJSON(STORAGE_SURVEY_KEY, payload);

export const readSurveyCacheFromStorage = () => storage.readJSON(STORAGE_SURVEY_KEY, {
  ignore: [] as SurveyIgnore[],
});

const initialState = {
  answers: [],
  surveys: [],
  activeSurveys: [],
  loading: false,
  isEnabled: false,
  ...readSurveyCacheFromStorage()
} as SurveyStore;

const mutations = (
  setState: (...params: Partial<SurveyStore>[]) => any,
  getState: () => SurveyStore
) => {
  return {
    fetchSurveys: async () => {
      try {
        setState({ loading: true, surveys: [] });
        const surveys = await SurveyHttp.fetchUserSurveys();
        setState({ loading: false, surveys });
        getState().filterActiveSurveys();
        return surveys;
      }
      catch (e) {
        return [];
      }
    },
    ignoreSurvey(id: number) {
      const cache = getState();
      const index = cache?.ignore?.findIndex(item => item.id === id);
      if (index >= 0) {
        cache.ignore[index] = { id, expire: expireTime() };
        writeSurveyCacheToStorage({ ignore: cache.ignore });
        setState({ ignore: [...cache.ignore] });
        getState().filterActiveSurveys();
        return;
      }
      const payload = { ignore: [...(cache?.ignore ?? []), { id, expire: expireTime() }] };
      writeSurveyCacheToStorage(payload);
      setState(payload);
      getState().filterActiveSurveys();
    },
    filterActiveSurveys() {
      const surveys = getState().surveys;
      const cache = readSurveyCacheFromStorage();
      const ignore = [...cache.ignore ?? []];
      const time = moment().unix();
      const remove = [];
      for (let i = 0; i < ignore?.length; i++) {
        if (time > ignore[i]?.expire) {
          remove.push(i);
        }
      }
      remove.forEach(i => ignore.splice(i, 1));
      const activeSurveys = surveys.filter(s => ignore.findIndex(x => x.id === s.id) < 0);
      setState({ activeSurveys });
    }
  };
};

export default create(combine(initialState, mutations as any));

function expireTime() {
  return moment().unix() + (6 * 60 * 60);
}
